import { RNG } from "rot-js";
import { Actor } from "../../actors/Actor";
import { BreedTypes } from "../../../data/breeds";
import EntityManager from "../../EntityManager";
import { gameData } from "../../GameManager";
import { makeEmptyRoom } from "../carving/roomHelpers";
import { BSPGenerate } from "../graph/BSPGenerator";
import { GraphNode } from "../graph/graphUtils";
import {
  placeActor,
  placeExistingWithWord,
  placeMonsters,
} from "../placement/MonsterPlacement";
import { placeShrines } from "../placement/ShrinePlacement";
import { BasicMap } from "../BasicMap";
import { connectRooms } from "./connections";
import { fillWithLetters } from "../../words/letters";
import { cavernGenerate } from "../cavern/CavernGenerator";
import { createDMap } from "../../../lib/dMap";
import { moveToEmpty } from "../Pathfinding";
import { buildOpenness } from "../placement/openness";
import {
  placeFountain,
  placeStairs,
  placeXPNode,
} from "../placement/FurniturePlacement";
import { MAP_DEPTH } from "../../gameState";
import { placeItems } from "../placement/ItemPlacement";

export const generateMap = (
  rng: typeof RNG,
  map: BasicMap,
  player?: Actor,
  playerWord?: string
) => {
  try {
    generateCavernMap(rng, map, player, playerWord);
  } catch (e) {
    console.error(e);
    throw e;
  }
  //return generateBSPMap(rng, map, player);
};

const generateBSPMap = (rng: typeof RNG, map: BasicMap, player?: Actor) => {
  const rooms = BSPGenerate(rng, map.width - 1, map.height - 1);
  map.generate(rng);
  let room: GraphNode;
  for (room of rooms.values()) {
    makeEmptyRoom(map, room.bounds);
  }

  connectRooms(rng, rooms, map);

  const [oldPos, startingRoom] = placeShrines(rng, map, rooms);
  if (player) {
    player.x = oldPos.x;
    player.y = oldPos.y;
  } else {
    gameData.player = EntityManager.createActor(
      BreedTypes.player,
      oldPos.x,
      oldPos.y
    );
    fillWithLetters(gameData.player, 10);
  }
  //placeMonsters(rng, map, rooms, startingRoom);
};

const generateCavernMap = (
  rng: typeof RNG,
  map: BasicMap,
  player?: Actor,
  playerWord?: string
) => {
  map.generate(rng);
  cavernGenerate(rng, map);
  const openness = buildOpenness(map);
  if (!player) {
    gameData.player = placeActor(
      rng,
      map,
      openness,
      BreedTypes.player
    ) as Actor;
    fillWithLetters(gameData.player, 10);
  } else {
    placeExistingWithWord(rng, map, openness, player, playerWord);
  }

  const playerDMap = createDMap(
    gameData.player.pieces.asArray(),
    moveToEmpty,
    80
  );
  placeMonsters(rng, map, openness, playerDMap);

  if (map.depth < MAP_DEPTH) {
    placeStairs(rng, map, playerDMap);
  }
  placeXPNode(rng, map, playerDMap);
  placeXPNode(rng, map, playerDMap);

  if (map.depth % 3 === 1) {
    placeFountain(rng, map, playerDMap);
  }

  placeItems(rng, map, playerDMap);
};
